// Workspace-level artefact edits. The in-thread pencil (RightPanel) goes over
// the `update-artifact` socket event, which requires the caller to be joined to
// the artefact's thread. The workspace surfaces — the Artefacts view and the
// desktop Work rail — open an artefact in the lightbox without joining its
// thread, so they save through the REST equivalent instead. Both paths land in
// Thread.updateArtifact, so an edit is versioned and broadcast either way.
const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

export async function updateWorkspaceArtifact(workspaceId, artifactId, { title, content }) {
  const token = localStorage.getItem('symphonate-token');
  const res = await fetch(`${SERVER_URL}/api/workspaces/${workspaceId}/artifacts/${artifactId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ title, content }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Could not save the artefact.');
  return data.artifact;
}

export default updateWorkspaceArtifact;
